module.exports = __webpack_public_path__ + "static/media/Gotham Rounded Light.6a4f95c7.woff";